import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { PositionState } from "./positionTypes";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";

export const usePositionReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.position);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<PositionState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<PositionState>;
};
